import { render, staticRenderFns } from "./PersonDocumentKindSearch.vue?vue&type=template&id=3eff89eb&"
import script from "./PersonDocumentKindSearch.vue?vue&type=script&lang=js&"
export * from "./PersonDocumentKindSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports